import type { FeaturedAlertItem } from "@/lib/api-client";

export type AutomationTag = "scanner" | "signal" | "report" | "portfolio" | "dashboard" | "alert";

export function getAutomationTag(item: Pick<FeaturedAlertItem, "name" | "description">): {
  kind: AutomationTag;
  label: string;
} {
  const text = `${item.name || ""} ${item.description || ""}`.toLowerCase();

  if (
    text.includes("premarket") ||
    text.includes("pre-market") ||
    text.includes("report") ||
    text.includes("digest") ||
    text.includes("brief") ||
    text.includes("recap") ||
    text.includes("morning")
  ) {
    return { kind: "report", label: "Report" };
  }

  if (
    text.includes("portfolio") ||
    text.includes("dividend") ||
    text.includes("cash flow") ||
    text.includes("income") ||
    text.includes("holding")
  ) {
    return { kind: "portfolio", label: "Portfolio" };
  }

  if (text.includes("dashboard") || text.includes("heatmap")) {
    return { kind: "dashboard", label: "Dashboard" };
  }

  if (
    text.includes("scan") ||
    text.includes("scanner") ||
    text.includes("radar") ||
    text.includes("watch") ||
    text.includes("screener")
  ) {
    return { kind: "scanner", label: "Scanner" };
  }

  if (
    text.includes("signal") ||
    text.includes("pulse") ||
    text.includes("long") ||
    text.includes("short") ||
    text.includes("buy") ||
    text.includes("sell")
  ) {
    return { kind: "signal", label: "Signal" };
  }

  return { kind: "alert", label: "Alert" };
}

export function getDisplaySubscriberCount(item: Pick<FeaturedAlertItem, "alert_id" | "subscriber_count">): number {
  if (Number.isFinite(item.subscriber_count) && item.subscriber_count > 0) {
    return item.subscriber_count;
  }

  return 300 + (stableHash(item.alert_id || "automation") % 1380);
}

export function formatAutomationCount(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return "0";
  if (n < 1000) return String(Math.round(n));
  if (n < 1_000_000) return `${(n / 1000).toFixed(n < 10_000 ? 1 : 0).replace(/\.0$/, "")}K`;
  return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
}

function stableHash(input: string): number {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return Math.abs(hash >>> 0);
}
